/* eslint react/jsx-indent: 0 */
/* eslint import/namespace: ['error', { allowComputed: true }] */
import React from 'react'
import _cx from 'classnames/bind'
import type { CombinedDocumentTypes } from '@adc/blueprint/lib/listing/pdp/types'
// @ts-ignore no types
import { connect } from 'react-redux'
import {
  hooks,
  // @ts-ignore no types
} from '@adc/ui-adc'
import instrument from '@adc/instrument'
import * as blueprint from '@adc/blueprint'
import { DocumentFile } from '../documents/documentFile'
import analytics from '../../services/analytics'
import { MobileViewDocument } from '../documents/mobileViewDocuments'
// @ts-ignore no types
import cls from './index.scss'

const cx = _cx.bind(cls)

type ExternalDocumentType = {
  label: string
  url: string
}

const DueDiligenceDocument = ({
  doc,
  externalDoc,
  elmId,
  disabled,
  disabledTooltip,
  fallbackTitle,
}: {
  doc?: CombinedDocumentTypes
  externalDoc?: ExternalDocumentType
  elmId: string
  disabled?: boolean
  disabledTooltip?: string
  fallbackTitle?: string
}) => {
  const isMobile = hooks.useIsMobileHook()
  const { getDocumentTitle, getDocumentType } = blueprint.listing.utils

  const viewSelectedDocument = () => {
    const documentLabel = getLabel()
    analytics.documents({
      display_label: documentLabel,
    })
    doc &&
      instrument.increment('pdp_document_click', 1, [
        `type:${getDocumentType(doc)}`,
      ])
    const redirectUrl = getDocumentUrl()
    if (redirectUrl?.length) {
      window.open(redirectUrl, '_blank')
    }
  }

  const getDocumentUrl = () => {
    if (externalDoc) {
      return externalDoc.url
    }
    return doc ? blueprint.listing.utils.getDocumentUrl(doc) : ''
  }

  const getLabel = () => {
    if (externalDoc) {
      return externalDoc.label
    }
    return doc ? getDocumentTitle(doc) : fallbackTitle || ''
  }

  if (isMobile) {
    return (
      <MobileViewDocument
        label={getLabel()}
        updatedDate={doc?.updated_date}
        elmId={elmId}
        disabled={disabled}
        disabledTooltip={disabledTooltip}
        onClick={viewSelectedDocument}
      />
    )
  }
  return (
    <div className={cx('u-mt-4', 'u-mb-4')}>
      <DocumentFile
        label={getLabel()}
        updatedDate={doc?.updated_date}
        viewSelectedDocument={viewSelectedDocument}
        elmId={elmId}
        disabled={disabled}
        disabledTooltip={disabledTooltip}
      />
    </div>
  )
}

export default DueDiligenceDocument
